import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import Headshot from "../components/Headshot";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Book An Event - Elm Street</title>
        <meta name="description" content="Book An Event with Elm Street Academy - Elm Street" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/book_an_event" />
        <meta property="og:title" content="Book An Event - Elm Street" />
        <meta property="og:description" content="Book An Event with Elm Street Academy - Elm Street" />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('bookbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Academy - Book an Event"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "520px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <div style={{ paddingTop: "8px" }}>
                      <Image src="/es_academy_logow.svg" width="260px" height="90px" alt="Elm Street Academy" />
                    </div>
                    <span style={{ color: mainTheme.palette.secondary.main }}>
                      book
                      <br />
                    </span>{" "}
                    an event
                  </Typography>
                  <p>
                    High-Energy, Insightful Education
                    <br />
                    Your Audience will Love.
                  </p>
                  <Button variant="contained" color="secondary" href="#form">
                    book your event!
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>




      <Container
        maxWidth="lg"
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingBottom: "25px",
          marginTop: "180px",
        }}
      >
 

        <Grid container spacing={16}>
          <Grid item md={6} sm={12} style={{ textAlign: "left", paddingTop:"25px", paddingBottom:"25px" }}>
              Social media and marketing are crucial, but most agents aren't maximizing their value due to lack of knowledge, fear of “messing up,” lack of time, or all of the above.
              <br /><br />
              Our goal is to CHANGE THAT by providing empowering and results-driven education to growth-minded real estate professionals.
              <br /><br />
              We use humor, practical advice, and real-life experiences to break down the walls that keep real estate professionals from utilizing social media and marketing practices to their fullest potential.
              <br /><br />
              <Typography variant="h5" component="h5">WE TEACH TOPICS<br />
              THAT <span style={{ color: mainTheme.palette.secondary.main }}>YOUR AGENTS NEED!</span></Typography>
          </Grid>

          <Grid item md={6} sm={12} style={{ textAlign: "left", paddingTop:"25px", paddingBottom:"25px" }}>
          <Typography variant="h5" component="h5">TOPICS <span style={{ color: mainTheme.palette.secondary.main }}>INCLUDE:</span></Typography>
          Social Media, Lead Generation, Repeat/Referral, Listing Strategies, Marketing Strategies, Lead Conversion, Technology Training &amp; MUCH MORE!
              <br /><br />
              <Typography variant="h5" component="h5">HOW IT <span style={{ color: mainTheme.palette.secondary.main }}>WORKS:</span></Typography>
              We partner with you to bring an educational experience to your office that INSPIRES, MOTIVATES &amp; CREATES EXCITEMENT!
              <br /><br />
              You provide the space and which topic you would like us to cover with your organization. We provide action-oriented education and a fun experience that will have attendees asking for more!
              <br /><br />
              <Typography variant="h5" component="h5">THE BEST PART?<br />
              ALL EDUCATIONAL EXPERIENCES<br />
              <span style={{ color: mainTheme.palette.secondary.main }}>ARE FREE TO HOST!</span></Typography>

          </Grid>
        </Grid>
      </Container>






      <Container
        maxWidth="lg"
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingBottom: "54px",
          paddingTop: "120px",
        }}
      >
 

        <Grid container spacing={16}>
          <Grid item md={6} sm={12} style={{ textAlign: "center", paddingTop:"25px", paddingBottom:"25px" }}>
          <div>
                  <Image
                    src="/mc1x1.jpg"
                    width="800px"
                    height="800px"
                    alt="Elm Street Academy Masterclass - Book a fun &amp; unique education experience for your office."
                  />
                </div>

                <div style={{paddingTop:"25px", paddingBottom:"15px"}}>Are you a broker (or agent) looking to expand the educational offerings in your office? 
You choose the topic, and we'll bring th inspiring education &amp; fun learning environment.</div>
<Button variant="contained" color="secondary" href="https://elmstreet.com/masterclass#form">
                    book your masterclass!
                  </Button>

          </Grid>
          <Grid item md={6} sm={12} style={{ textAlign: "center", paddingTop:"25px", paddingBottom:"25px" }}>
          <div>
                  <Image
                    src="/bookmls.jpg"
                    width="800px"
                    height="800px"
                    alt="Elm Street - Book an impactful educational experience for your MLS or association."
                  />
                </div>
                <div style={{paddingTop:"25px", paddingBottom:"15px"}}>Are you an MLS/Association and want to increase the educational offerings your organization provides? 
You choose the topic and we'll work with you to create a meaningful experience for your network.</div>
<Button variant="contained" color="secondary" href="https://elmstreet.com/mls_associations#form">
                    book your event today!
                  </Button>
          </Grid>
        </Grid>
      </Container>





<div style={{backgroundColor:"#f7f7f7"}}>


      <Container
        maxWidth="lg"
        style={{
          paddingLeft: "25px",
          paddingRight: "25px",
          paddingBottom: "70px",
          paddingTop: "60px",
        }}
      >
        <div
          style={{
            marginTop: "55px",
            marginBottom: "55px",
            textAlign: "center",
          }}
        >
       
          <Typography variant="h5" component="h5">
            need more <span style={{ color: "#f69c26" }}>information?</span>
          </Typography>
          Fill out the form below or connect with us directly!
        </div>

        <Grid container spacing={16} style={{ paddingTop:"85px", }}>
          <Grid item md={4} sm={12} xs={12} style={{ paddingBottom: "25px", paddingTop:"25px", textAlign: "center" }}>
            <Headshot
              src="/headshots/tcolthorp.jpg"
              name=""
              title=""
              style={{ paddingBottom: "12px" }}
              alt="Elm Street Academy - Todd Colthorp"
            />
            <Typography variant="h5" component="h5">
              MLS &amp; Associations
            </Typography>
            <strong style={{ color: "#f69c26" }}>Todd Colthorp</strong>
            <br />
            VP MLS &amp; Industry Relations
            <br />
            <a href="mailto:todd.colthorp@elmstreet.com">todd.colthorp@elmstreet.com</a>
            <br />
            517.214.3333
          </Grid>
          <Grid item md={4} sm={12} xs={12} style={{ paddingBottom: "25px", paddingTop:"25px", textAlign: "center" }}>
            <Headshot
              src="/headshots/salfonso.jpg"
              name=""
              title=""
              style={{ paddingBottom: "12px" }}
              alt="Elm Street Academy - Stephanie Alfonso"
            />
            <Typography variant="h5" component="h5">
              Brokerages
            </Typography>
            <strong style={{ color: "#f69c26" }}>Stephanie Alfonso</strong>
            <br />
            Director, Sales Enablement<br />
            &amp; Solution Engineering
            <br />
            <a href="mailto:stephanie.alfonso@elmstreet.com">stephanie.alfonso@elmstreet.com</a>
            <br />
            813.924.1506
          </Grid>
          <Grid item md={4} sm={12} xs={12} style={{ paddingBottom: "25px", paddingTop:"25px", textAlign: "center" }}>
            <Headshot
              src="/headshots/moleary.jpg"
              name=""
              title=""
              style={{ paddingBottom: "12px" }}
              alt="Elm Street Academy - Meagan O'Leary"
            />
            <Typography variant="h5" component="h5">
              Conferences &amp; Events
            </Typography>
            <strong style={{ color: "#f69c26" }}>Meagan O'Leary</strong>
            <br />
            Director of Education
            <br />
            <a href="mailto:meagan.oleary@elmstreet.com">meagan.oleary@elmstreet.com</a>
            <br />
            720.849.0862
          </Grid>
        </Grid>
      </Container>

      </div>


      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
          <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              book an event today!
            </Typography>
            <div style={{ paddingBottom: "15px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>
                Fill out the following form and a member of our Education Team will connect shortly.
              </strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Book an Event"
                      successUrl="thankyou"
                      listId="148005"
                      formName="es2_book_event"                      
                      fieldList={["first_name", "last_name", "email", "phone", "roll"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};